import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-rs-vohra',
  templateUrl: './rs-vohra.component.html',
  styleUrls: ['./rs-vohra.component.scss']
})
export class RsVohraComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getRSVohra();
  }

}
